import React from 'react';

const ToggleButtonGroup = ({ items, selectedItem, onItemClick }) => {
    return (
        <div className="toggle-button-group">
            {items.map((item, index) => (
                <button
                    key={index}
                    className={`toggle-button ${selectedItem.toLowerCase() === item.value.toLowerCase() ? 'selected' : ''}`}
                    onClick={() => onItemClick(item)}
                >
                    {item.value}
                </button>
            ))}
        </div>
    );
};

export default ToggleButtonGroup;